<template>
  <div>
    <b-modal
      title="全部順延名單"
      size="lg"
      centered
      hide-footer
      header-class="head-modal"
      v-model="modalShow"
    >
      <div class="contract-data">
        <div>會員編號：{{ data.number }}</div>
        <div>姓名：{{ data.member_name }}</div>
        <div>入會日：{{ convertRocDate(data.join_date) }}</div>
      </div>

      <tables-page
        :tableData="table_data"
        :tableFields="table_fields"
        v-on:result="getDeferred"
      >
        <template #cell(dead_at)="row">
          {{ convertRocDate(row.item.dead_at) }}
        </template>

        <template #cell(accept_at)="row">
          {{ convertRocDate(row.item.accept_at) }}
        </template>
      </tables-page>

      <b-overlay :show="status.isLoading" no-wrap></b-overlay>
    </b-modal>
  </div>
</template>

<script>
import TablesPage from "@/components/layouts/TablesPage";
import contractApi from "@/models/API/contractApi";
import { countNoNum, convertRocDate} from "@/models/HELPERS/common.js";

export default {
  name: 'AllPostponementListModal',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      required: false,
      default: false
    },
    data: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  components: {
    TablesPage
  },
  data () {
    return {
      status: {
        isLoading: false
      },
      table_fields: [
        {
          key: "no",
          label: "No",
        },
        {
          key: "plan",
          label: "組別",
        },
        {
          key: "number",
          label: "契約編號",
        },
        {
          key: "member_ID_number",
          label: "身分證",
        },
        {
          key: "member_name",
          label: "姓名",
        },
        {
          key: "dead_at",
          label: "身故日期",
        },
        {
          key: "accept_at",
          label: "受理日期",
        },
        {
          key: "period",
          label: "期別",
        },
        {
          key: "mark",
          label: "註記",
        },
      ],
      page: {},
      table_data: [],
    }
  },
  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('change', value);
      }
    },
  },
  watch: {
    show: {
      handler(newValue, oldValue) {
        if (newValue) this.getDeferred();
      },
      immediate: false
    }
  },
  mounted() {
    this.contractApi = new contractApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      this.page = Object.assign({}, this.contractApi.page);
    },
    convertRocDate,
    // 查詢遞延
    getDeferred() {
      this.status.isLoading = true;

      const params = {
        'member_id': this.data.id,
        'all': 1,
        'PageSize': 99999,
        'PageIndex': 1,
      };

      this.contractApi.getDeferred((response) => {
        const res = response.data;

        this.page.totalCount = res.total; // 總筆數

        let temp_period = '', plan_no = 1, mark = '', deferred_num = 0, help_num = 0, stop_num = 0;

        this.table_data = res.data.map((item, index) => {
          if (temp_period !== item.period) {
            temp_period = item.period;
            plan_no = 1;
          } else {
            plan_no++;
          }

          if (item.type === 0) {
            deferred_num++;
            mark = `順延${deferred_num}`;
          } else if (item.type === 1) {
            help_num++;
            mark = `${item.period}期互助_${help_num}`
          } else if (item.type === 2) {
            stop_num++;
            mark = `停效期互助_${stop_num}`
          }

          return {
            ...item,
            no: countNoNum(this.page, index),
            plan: `${item.plan}_${plan_no}`,
            mark: mark
          }
        });

        this.status.isLoading = false;
      }, params, false)
    },
  }
}
</script>

<style lang="scss" scoped>
.contract-data {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/components/modal/AllPostponementListModal.vue